import React from 'react';
import Sidebar from './Sidebar';
import Content from './Content';

function App() {
  return (
    <React.Fragment>
      <Sidebar />
      <Content />
    </React.Fragment>
  );
}

export default App;
